import { __assign } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { ErrorWidget } from '@keen.io/widgets';
import { getPubSub } from '@keen.io/pubsub';
import { extendTheme } from '@keen.io/charts';
import { renderWidget } from './render-widget';
import text from './text.json';
import { extendChartSettings, extendWidgetSettings, prepareVisualization, createChartSettings, validateOptions, } from './utils';
var Visualizer = (function () {
    function Visualizer(options) {
        this.presentationTimezone = null;
        this.useKeenAsDataSource = true;
        validateOptions(options);
        var container = options.container, type = options.type, presentationTimezone = options.presentationTimezone, mappings = options.mappings, widget = options.widget, settings = options.settings, eventBus = options.eventBus, inEditMode = options.inEditMode;
        this.mappings = mappings || null;
        this.presentationTimezone = presentationTimezone;
        this.eventBus = eventBus || getPubSub();
        this.inEditMode = inEditMode || false;
        this.componentSettings = settings || {};
        this.widgetSettings = widget || {};
        this.container = container;
        this.type = type;
        if ('data' in this.componentSettings) {
            this.useKeenAsDataSource = false;
        }
    }
    Visualizer.prototype.getContainerNode = function () {
        return this.container instanceof HTMLElement
            ? this.container
            : document.querySelector(this.container);
    };
    Visualizer.prototype.setComponentSettings = function (input, widgetType, keys) {
        if (input === void 0) { input = {}; }
        var componentSettings = __assign({}, this.componentSettings);
        if ('theme' in this.componentSettings) {
            var theme = this.componentSettings.theme;
            componentSettings = __assign(__assign({}, componentSettings), { theme: extendTheme(theme) });
        }
        var query = {};
        if (input.query)
            query = input.query;
        componentSettings = extendChartSettings(createChartSettings({ query: query, widgetType: widgetType, keys: keys, componentSettings: componentSettings }), componentSettings);
        return componentSettings;
    };
    Visualizer.prototype.setWidgetSettings = function () {
        return extendWidgetSettings(this.widgetSettings, this.type);
    };
    Visualizer.prototype.destroy = function () {
        var container = this.getContainerNode();
        ReactDOM.unmountComponentAtNode(container);
    };
    Visualizer.prototype.error = function (message, title) {
        var container = this.getContainerNode();
        var settings = this.setWidgetSettings();
        ReactDOM.render(React.createElement(ErrorWidget, __assign({ message: message, header: title }, settings)), container);
    };
    Visualizer.prototype.render = function (input) {
        if (input === void 0) { input = {}; }
        var container = this.getContainerNode();
        var keys = [];
        var results = [];
        var parseQuery = arguments.length && this.useKeenAsDataSource;
        if (parseQuery) {
            var parser = prepareVisualization(input, this.mappings, this.componentSettings, this.type, this.presentationTimezone);
            keys = parser.keys;
            results = parser.results;
        }
        var isEmptyAnalysisResult = this.useKeenAsDataSource &&
            (results.length === 0 ||
                (Array.isArray(input.result) && input.result.length === 0));
        if (isEmptyAnalysisResult) {
            return this.error(text.empty_analysis_result);
        }
        ReactDOM.render(renderWidget({
            type: this.type,
            eventBus: this.eventBus,
            inEditMode: this.inEditMode,
            widgetSettings: this.setWidgetSettings(),
            componentSettings: this.setComponentSettings(input, this.type, keys),
            data: results,
            keys: keys,
        }), container);
    };
    return Visualizer;
}());
export default Visualizer;
